import { Flex } from '@wegroup/design-system';
import React from 'react';

interface TableFillerProps {
  borderColor?: string;
  children?: React.ReactNode;
}

const TableFiller: React.FC<TableFillerProps> = ({
  children,
  borderColor = 'gray.strokeAndBg',
}) => {
  return (
    <Flex
      flexGrow={1}
      p="10"
      width="100%"
      border="1px solid"
      borderTop="unset"
      borderRadius="md"
      borderTopLeftRadius="unset"
      borderTopRightRadius="unset"
      borderColor={borderColor}
      bg="white"
      justifyContent="center"
      alignItems="center"
      boxShadow="level1"
    >
      {children}
    </Flex>
  );
};

export default TableFiller;
